import ProjectService from '@/services/projectService'
import { Promise } from 'core-js'

// state
const state = {
  buildings: [],
  selectedProject: { name: '' },
  selectedBuilding: null,
  selectedFloor: null,
  selectedZone: null,
  projectList: []
}

// getters
const getters = {
  buildings: state => state.buildings,
  project: state => state.selectedProject,
  selectedBuilding: state => state.selectedBuilding,
  selectedFloor: state => state.selectedFloor,
  selectedZone: state => state.selectedZone,
  projectList: state => state.projectList
}

// actions
const actions = {
  getBuildingsAsync({ commit, state, rootState, dispatch }, projectId) {
    commit('ISLOADING', true)
    const bh = rootState.auth.bearerToken
    if (projectId && bh) {
      const res = ProjectService.getBuildings(projectId).then(res => {
        if (res.data.buildings.length == 0) {
          commit('ISLOADING', false)
        }
        res.data.buildings.forEach(el => {
          let storyCount = 0
          let zoneCount = 0
          el.storiesDetailsDataFetched = false

          el.stories.forEach(s => {
            storyCount++
            el.zonesDetailsDataFetched = false
            s.lastModification = '2000-01-01T00:00:01'
            s.zones.forEach(z => {
              zoneCount++
              z.lastModification = '2000-01-01T00:00:01'
            })
          })
          el.floorCount = storyCount
          el.zoneCount = zoneCount
          el.openingCount = ''
          el.lastModification = '2000-01-01T00:00:01'
        })

        dispatch('getOpeningCountForBuildings', res.data.buildings).then(resWithCount => {
          commit('SET_BUILDINGS', resWithCount)
        })
      })
    }
  },
  async getStoriesAsync({ commit, state, rootState }, [projectId, buildingId]) {
    commit('ISLOADING', true)

    const bh = rootState.auth.bearerToken
    if (projectId && bh) {
      const res = await ProjectService.getBuildings(projectId)

      const index = res.data.buildings.findIndex(o => o.buildingId == buildingId)
      const el = res.data.buildings[index]

      let storyCount = 0
      let zoneCount = 0

      el.openingCount = ''
      el.lastModification = '2000-01-01T00:00:01'
      el.storiesDetailsDataFetched = false
      if (el.stories.length == 0) {
        console.log(`no floors for ${el.name}`)
      }

      await Promise.all(
        el.stories.map(async s => {
          storyCount++
          el.zonesDetailsDataFetched = false
          s.lastModification = '2000-01-01T00:00:01'

          const oc = await ProjectService.getOpeningCountForFloor(projectId, s.storyId)
          s.openingCount = oc.data

          const lm = await ProjectService.getLastModificationForFloor(projectId, s.storyId)
          if (lm) {
            s.lastModification = lm.data
          }

          s.zones.forEach(z => {
            zoneCount++
            z.lastModification = '2000-01-01T00:00:01'
          })

        })
      ); //await promise.all

      el.floorCount = storyCount
      el.zoneCount = zoneCount
      commit('SET_FLOORS_SELECTED_BUILDING', el.stories)

    }
    commit('ISLOADING', false)

  },
  getOpeningCountForBuildings({ state, commit, dispatch }, buildings) {
    let resItems = 0
    const totItems = buildings.length

    return new Promise((resolve, reject) => {
      buildings.forEach(element => {
        ProjectService.getOpeningCountForBuilding(state.selectedProject.projectId, element.buildingId).then(res => {
          element.openingCount = res.data
          if (res.data > 0) {
            ProjectService.getLastModificationForBuilding(state.selectedProject.projectId, element.buildingId)
              .then(res => {
                element.lastModification = res.data
                resItems++
                if (resItems >= totItems - 1) commit('ISLOADING', false)
              })
              .catch(err => {
                resItems++
                if (resItems >= totItems - 1) commit('ISLOADING', false)
              })
          } else {
            resItems++
            if (resItems >= totItems - 1) commit('ISLOADING', false)
          }
        })
      })
      resolve(buildings)
    })
  },
  getLastModificationForBuildings({ commit }, buildings) {
    return new Promise((resolve, reject) => {
      buildings.forEach(element => {
        ProjectService.getLastModificationForBuilding(state.selectedProject.projectId, element.buildingId).then(res => {
          element.lastModification = res.data
        })
      })
      resolve(buildings)
    })
  },
  setProject({ commit, state }, project) {
    if (state.selectedProject && state.selectedProject.projectId != project.projectId) {
      commit('SET_BUILDINGS', [])
    }
    commit('SET_PROJECT', project)
  },
  async getProjectList({ commit, state }) {
    state.projectList = []
    const res = await ProjectService.getProjectList()
    res.data.projects.forEach(function (projectData) {
      commit('addToProjectList', projectData)
    })
  },
  async createProject({ commit, dispatch, state }, projectData) {
    const res = await ProjectService.createProject(projectData)
    commit('addToProjectList', res.data)
  },
  async deleteProject({ commit }, projectId) {
    await ProjectService.deleteProject(projectId)
    commit('removeFromProjectList', projectId)
  },
  async updateSelectedProject({ state, dispatch, commit }, projectData) {
    const res = await ProjectService.updateProject(projectData)
    commit('SET_PROJECT', projectData)
  }
}

// mutations
const mutations = {
  SET_BUILDINGS(state, buildings) {
    state.buildings = buildings
  },
  SET_PROJECT(state, project) {
    state.selectedProject = project
  },
  SET_SELECTED_BUILDING(state, building) {
    state.selectedBuilding = building
  },
  SET_FLOORS_SELECTED_BUILDING(state, floors) {
    state.selectedBuilding.stories = floors
  },
  SET_SELECTED_FLOOR(state, floor) {
    state.selectedFloor = floor
  },
  SET_SELECTED_ZONE(state, zone) {
    if (zone.openings == null) zone.openings = []
    if (!zone.openingsDetailsDataFetched) zone.openingsDetailsDataFetched = false
    state.selectedZone = zone
  },
  SET_OPENINGS_FOR_SELECTED_ZONE(state, openings) {
    openings.map(o => {
      o.photos.forEach(p => {
        if (!o.status) {
          o.status = p.registrationType
          o.captureTime = p.captureTime
        } else {
          if (p.captureTime > o.captureTime) {
            o.status = p.registrationType
            o.captureTime = p.captureTime
          }
        }
      })
      return o
    })
    state.selectedZone.openings = openings
  },
  addToProjectList(state, projectData) {
    state.projectList.push(projectData)
  },
  removeFromProjectList(state, projectId) {
    const index = state.projectList.findIndex(obj => obj.projectId == projectId)
    state.projectList.splice(index, 1)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/project.js